import { useContext } from 'react';
import Sections from '~/constants/home/sections';
import InternalLinkContext from '~/context/home/InternalLinkContext';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import { SectionWrapper } from './InternalLinks.styles';
import { LinkSection } from './LinkSection';

enum InternalLinkType {
  BodyStyle = 'bodyStyles',
  PopularMakesModels = 'popularMakesModels',
  TopLocations = 'topLocations'
}

function InternalLinks() {
  const { internalLinksGroups } = useContext(InternalLinkContext);

  return (
    <SectionWrapper>
      <LinkSection
        {...internalLinksGroups[InternalLinkType.PopularMakesModels]}
      />
      <LinkSection {...internalLinksGroups[InternalLinkType.BodyStyle]} />
      <LinkSection {...internalLinksGroups[InternalLinkType.TopLocations]} />
    </SectionWrapper>
  );
}

export default withErrorBoundary(
  InternalLinks,
  undefined,
  undefined,
  Sections.InternalLinks
);
